import React, { useState, useEffect } from 'react';
import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_URL;  // 환경 변수로 API URL 불러오기

const Dashboard = () => {
  const [userInfo, setUserInfo] = useState(null);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');

  // 로그아웃 함수
  const handleLogout = async () => {
    const refreshToken = localStorage.getItem('refreshToken');  // Refresh token 확인
    const accessToken = localStorage.getItem('accessToken');  // Access token 확인
  
    if (!refreshToken || !accessToken) {
      console.log('로그아웃할 토큰이 없습니다.');
      return;
    }
  
    try {
      // 로그아웃 요청에 Authorization 헤더에 accessToken 추가
      const response = await axios.post(`${apiUrl}/accounts/logout/`, {
        refresh: refreshToken  // 서버로 refresh token 전송
      }, {
        headers: {
          'Authorization': `Bearer ${accessToken}`  // Access token을 Authorization 헤더에 추가
        }
      });
  
      if (response.status === 205 || response.status === 200) {
        console.log('로그아웃 성공:', response.data);
  
        // 토큰 삭제
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
  
        // 로그아웃 후 로그인 페이지로 이동
        window.location.href = '/login';
      } else {
        console.log('로그아웃 응답 상태:', response.status);
      }
    } catch (error) {
      console.error('로그아웃 실패:', error.response ? error.response.data : error.message);
    }
  };

  // 서버에서 사용자 정보 및 대시보드 데이터를 가져오는 함수
  const fetchUserInfo = async () => {
    const accessToken = localStorage.getItem('accessToken');
    const refreshToken = localStorage.getItem('refreshToken');

    if (!accessToken) {
      setError('You need to login first');
      return;
    }

    try {
      // 토큰 검증 요청
      await axios.post(`${apiUrl}/token/verify/`, {
        token: accessToken
      });

      // 검증 통과 후 보호된 리소스 요청
      const response = await axios.get(`${apiUrl}/accounts/protected-endpoint/`, {
        headers: {
          'Authorization': `Bearer ${accessToken}`
        }
      });

      setUserInfo(response.data);  // 사용자 정보 저장

    } catch (error) {
      if (error.response && error.response.status === 401) {
        console.log('토큰이 만료됨. 새 토큰을 요청 중...');
        // 토큰이 만료된 경우 새 액세스 토큰 요청
        if (refreshToken) {
          try {
            const refreshResponse = await axios.post(`${apiUrl}/accounts/token/refresh/`, {
              refresh: refreshToken
            });

            const newAccessToken = refreshResponse.data.access;
            localStorage.setItem('accessToken', newAccessToken);

            // 새로 받은 액세스 토큰으로 보호된 리소스 다시 요청
            const retryResponse = await axios.get(`${apiUrl}/accounts/protected-endpoint/`, {
              headers: {
                'Authorization': `Bearer ${newAccessToken}`
              }
            });

            setUserInfo(retryResponse.data);

          } catch (refreshError) {
            console.error('토큰 갱신 실패:', refreshError.response ? refreshError.response.data : refreshError.message);
            setError('Failed to refresh token. Please log in again.');
            handleLogout();  // 토큰 갱신 실패 시 로그아웃 처리
          }
        } else {
          setError('Refresh token is missing. Please log in again.');
          handleLogout();
        }
      } else {
        console.error('Error fetching user info:', error.response ? error.response.data : error.message);
        setError('Failed to load your page');
      }
    }
  };

  useEffect(() => {
    fetchUserInfo();
  }, []);  // 컴포넌트가 마운트될 때 한 번 실행

  if (error) {
    return <div>{error}</div>;
  }

  if (!userInfo) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <h1>대시보드</h1>
      <h1>Welcome, {userInfo.username}!</h1>
      <p>Your Login ID: {userInfo.login_id}</p>
      <button onClick={handleLogout}>로그아웃</button>
      {message && <p>{message}</p>}
    </div>
  );
};

export default Dashboard;
